import Decimal from 'decimal.js';

const MAX_PERCENTAGE = 100;
const SAFETY_MARGIN = 0.1;

export const calculateEditableMarginLimit = (
  expensesPercent: number | null | undefined,
  salesTaxPercentage: number | null | undefined,
  cost: number | null | undefined,
): number | null => {
  if (expensesPercent == null || salesTaxPercentage == null || cost == null) return null;

  return Decimal.max(0, new Decimal(MAX_PERCENTAGE).minus(expensesPercent).minus(salesTaxPercentage).minus(SAFETY_MARGIN))
    .toDecimalPlaces(1, Decimal.ROUND_FLOOR)
    .toNumber();
};

export const formatEditableMarginLimit = (limit: number) => limit.toFixed(1).replace('.', ',');
